/**
 * Generato automaticamente.
 * OpenAPI
 */

export type EnumTipoDomandaModuloDTOTipoAssociazione =
  (typeof EnumTipoDomandaModuloDTOTipoAssociazione)[keyof typeof EnumTipoDomandaModuloDTOTipoAssociazione];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumTipoDomandaModuloDTOTipoAssociazione = {
  PRINCIPALE: 'PRINCIPALE',
  SECONDARIO: 'SECONDARIO',
  DINAMICO: 'DINAMICO',
} as const;
